<template>
    <button
            class="btn btn-primary"
            type="button"
            onclick="
            if (this.form.checkValidity()) {
                if(confirm('Are you sure you want to submit?\n\nCAUTION: You cannot change anything after you submit!')){
                    $(this.firstChild).addClass('fa-spinner');
                    $(this.firstChild).removeClass('fa-check');
                    $(this.firstChild).addClass('fa-spin');
                    this.disabled = true;
                    this.form.submit();
                }
            } else {
                alert('You have to provide all the required data')
            }
"
    ><i class="fa fa-check"> </i> {{title}}
    </button>
</template>

<script>
    export default {
        props: {
            title: {
                default: "Submit"
            },
        },

    }
</script>